import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Achievement from '../views/Achievement.vue'
import First from '../views/First.vue'
import Tutorial from '../views/Tutorial.vue'
import Concerning from '../views/Concerning.vue'
import My from '../views/My.vue'
import { redirectToLogin } from '../utils/auth'
// 分类
import Class from '../views/Class.vue'
// 星系分类

// 个人中心
// import My from '../views/My'

const routerPush = VueRouter.prototype.push;

VueRouter.prototype.push = function (location) {

  return routerPush.call(this, location).catch(err => { })

};
Vue.use(VueRouter)

// 开发环境配置
const isDevMode = process.env.VUE_APP_DEV_MODE === 'true';
const autoLogin = process.env.VUE_APP_AUTO_LOGIN === 'true';

// 认证检查函数
const checkAuth = (to, from, next) => {
  // 开发环境且启用自动登录，直接放行
  if (isDevMode && autoLogin) {
    console.log('[开发模式] 跳过OAuth认证检查');
    next();
    return;
  }
  
  // 生产环境检查Token
  if (localStorage.getItem('Token-Circus') == null) {
    // 跳转到OAuth登录
    redirectToLogin()
  } else {
    next();
  }
};


const routes = [

  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    redirect: '/home/first',
    component: HomeView,

    children: [
      // 首页
      {
        path: 'first',
        name: 'first',
        component: First,
      },
      // 教程
      {
        path: 'tutorial',
        name: 'tutorial',
        component: Tutorial
      },
      // 分类
      {
        path: 'class',
        name: 'class',
        component: Class,
        beforeEnter: checkAuth
      },
      // 成果
      {
        path: 'achievement',
        name: 'achievement',
        component: Achievement,
      },
      // 关于
      {
        path: 'concerning',
        name: 'concerning',
        component: Concerning,
      },
      // 个人中心
      {
        path: 'my',
        component: My,
        beforeEnter: checkAuth
      }
    ]
  },

]



const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes

})

export default router
